import userModule from './modules/users';
import contactModule from './modules/contacts';
import groupModule from './modules/groups';
import navigationModule from './modules/navigation';
import birthdaySendModule from './modules/birthdaySend';
import {createStore} from "vuex";
import createPersistedState from "vuex-persistedstate";

const store = createStore({
    plugins: [createPersistedState()],
    modules: {
        user: userModule,
        groups: groupModule,
        contacts: contactModule,
        navigation: navigationModule,
        birthdaySend: birthdaySendModule
    }
});

export default store;
